import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list:this.props.list,
      value: this.props.list.find(i => i.nombre === this.props.default),
    }
  }
  componentDidUpdate(prevProps) {
    if(prevProps.list !== this.props.list) {
      this.setState({list: this.props.list, value: this.props.list.find(i => i.nombre === this.props.default)});
    }
  }

  changeFilter = (event, value) => {
    const {label}=this.props
    this.props.InfoAutoComplete(label,value)
    this.setState({value})
  };

  render(){
    const {list } =this.state
    const { label, placeholder } = this.props;
    return (
      <Autocomplete
        defaultValue={this.state.value ?? list[0]}
        options={list}
        getOptionLabel={option => option.nombre}
        onChange={this.changeFilter}
        closeIcon=""
        renderOption={params => {
          return (
              <div>{params.nombre}</div>
          );
        }}
        value={this.state.value}
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            label={label}
            placeholder={placeholder}
            fullWidth
            size='small'
          />
        )}
      />
        
    );
  }
}


export default compose(withRouter, withStyles(styles))(Filter);